import utils from './index.js'
/* eslint-disable */
export default class UrlUtils {
  constructor(uriString) {
    console.log(1)
  }
  // 收到Uri信息
  receiveLinkUri(uriString, vue) {
    if (!uriString) {
      this.showLog('收到Uri:uri与uriString不能同时为空');
      return;
    }
    let uriRouter;
    try {
      if (uriString.indexOf('openminiprogram') > -1) {
        uriRouter = this.parse(uriString.split('?')[0]);
      } else {
        uriRouter = this.parse(uriString);
      }
    } catch (e) {
      this.showLog('收到Uri:解析uriString异常:' + e.toString());
      return;
    }
    const scheme = uriRouter.scheme;
    const host = uriRouter.host;
    const path = uriRouter.path;
    let queryParameters = uriString.indexOf('openminiprogram') > -1 ? utils.getQueryObject(uriString) : uriRouter.query;
    this.showLog('收到Uri:scheme:' + scheme);
    this.showLog('收到Uri:host:' + host);
    this.showLog('收到Uri:path:' + path);
    this.showLog('收到Uri:queryParameters:' + Object.prototype.toString.apply(queryParameters));

    if (host === 'openrouter') {
      if (!host || !path) {
        this.showLog('收到Uri:host或者path为空');
        return;
      }
      let queryParametersStr = '';
      queryParameters && (queryParametersStr = this.genParamsStr(uriRouter.query));
      if(path.indexOf('/pages/webView/webView') > -1){
        var windowOpen = window.open()
        windowOpen.location.href = decodeURIComponent(queryParameters.url);
      }else{
        vue.$router.push({path: queryParameters ? `${path}?${queryParametersStr}` : path})
      }
      
      return 
    } else if (host === 'switchtab') {
      if (!host || !path) {
        this.showLog('收到Uri:host或者path为空');
        return;
      }

      return path
    } else if (host === 'openminiprogram') {
      this.showLog('开发中')
    }
  }
  showLog(message) {
    console.warn('UrlUtils:' + message);
  }
  // 解析url
  parse(url) {
    const urlObj = {
      scheme: /^(.+)\:\/\//,
      host: /\:\/\/(.+?)[\?\#\s\/]/,
      path: /\w(\/.*?)[\?\#\s]/,
      hash: /\#(\w+)\s$/,
      query: /\?(.+?)[\#\/\s]/
    }
    url += ' '

    function formatQuery(str) {
      return str.split('&').reduce((a, b) => {
        const arr = b.split('=')
        a[arr[0]] = arr[1]
        return a
      }, {})
    }
    for (let key in urlObj) {
      const pattern = urlObj[key]
      urlObj[key] = key === 'query' ? (pattern.exec(url) && formatQuery(pattern.exec(url)[1])) : (pattern.exec(url) && pattern.exec(url)[1])
    }
    return urlObj
  }
  genParamsStr(queryParams) {
    return this.createExportsUrlParama(queryParams)
  }
  createExportsUrlParama(paramsObj) {
    let paramsStr = '';
    Object.keys(paramsObj).map((key) => {
      paramsStr += key + '=' + paramsObj[key] + '&';
    })
    paramsStr = paramsStr.substring(0, paramsStr.length - 1)
  
    console.log(paramsStr);
    return paramsStr
  }
}


